import React from "react";
import {Box, Text} from "@unibuddy/patron";
import {MESSAGE_CHARACTER_LIMIT} from "../../utils/constants";

type ChatMessageCharacterCountProps = {
    count: number;
};

export function ChatMessageCharacterCount({count}: Readonly<ChatMessageCharacterCountProps>) {
    const color = count <= MESSAGE_CHARACTER_LIMIT ? "grey600" : "red800";
    return (
        <Box marginTop="small" marginRight="xlarge" marginBottom="xxsmall">
            <Text size="xsmall" color={color} align="end">
                {count} / {MESSAGE_CHARACTER_LIMIT}
            </Text>
        </Box>
    );
}
